import api from 'services/api';

/**
 * Models that record events. `events.enabled` defaults to true when a model
 * does not set it (schema-api-server getConfigNormalized), so models are
 * excluded only when they opt out explicitly.
 *
 * @returns {Promise<object[]>}
 */
export async function fetchEventModels() {
  try {
    const result = await api.get('/data/:models', {
      'events.enabled': { $ne: false },
      abstract: { $ne: true },
      deprecated: { $ne: true },
      limit: 1000,
      fields: [
        'name',
        'namespace',
        'label',
        'plural',
        'app_id',
        'client_id',
        'extends',
        'events',
        'fields',
      ],
    });

    return result?.results || [];
  } catch (err) {
    console.error('Error fetching event models', err);
    return [];
  }
}
